import * as React from "react";

function IconButton(props) {
    return (
        <svg
            width={202}
            height={48}
            viewBox="0 0 202 48"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                id="button-dashed"
                d="M22.145 1h-3.547c-23.464 0-23.464 46 0 46h163.703c24.556 0 24.556-46 2.183-46H22.145z"
                stroke="currentColor"
                fill="transparent"
                fillRule="evenodd"
                strokeDasharray="25.6,12"
            />
        </svg>
    );
}

export default IconButton;
